import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '@/views/Dashboard';
import Patients from '@/views/Patients';
import Physicians from '@/views/Physicians';
import Rooms from '@/views/Rooms';
import Users from '@/views/Users';
import SearchAddNewPatient from '@/views/SearchAddNewPatient';
import User from '@/views/User';
import Patient from '@/views/Patient';
import Layout from '@/components/Layout';
import Logout from '@/components/Logout';
import Loader from '@/components/Loader';
import Problem from '@/components/Problem';
import Consultation from '@/views/Consultation'
import Room from '@/views/Room'
import AccountSetup from '@/views/AccountSetup'
import StatusOverview from '@/views/StatusOverview'
import DataAnalytics from '@/views/DataAnalytics'
import AccessControl from '@/views/AccessControl'
import i18n from "./lang/lang";

Vue.use(Router);

const router = new Router({
    mode: 'history',

    routes: [
        {
            path: '/',
            name: 'layout',
            component: Layout,
            children: [
                get('/dashboard', 'dashboard', Dashboard, "dashboard", true, true, true, true),
                get('/search_add_new_patient', 'search_add_new_patient', SearchAddNewPatient, "searchAddNewPatient" ,true, true, true, true),
                get('/consultation', 'consultation', Consultation, "consultation", true, true, true, true),
                get('/rooms', 'rooms', Rooms, "rooms", true, true, true, true),
                get('/room/:roomId', 'room', Room, "room", true, true, true, true),
                get('/patients', 'patients', Patients, "patients", false, true, true, true),
                get('/physicians', 'physicians', Physicians, "physicians", false, true, true, true),
                get('/users', 'users', Users, "users",  false, false, true, true),
                get('/data_analytics', 'data_analytics', DataAnalytics, "dataAnalytics",  false, false, true, true),
                get('/status_overview', 'status_overview', StatusOverview, "statusOverview",  false, true, true, true, true),

                get('/auth_callback', 'auth_callback'),
                get('/login', 'login'),
                get('/users/:id', 'user', User,'User',  false, false, true),
                get('/patients/:id', 'patient', Patient,'Patient',  true, true, true, true),
                get('/access_control','access_control',AccessControl,'AccessControl',false, false, true, true),
            ],
            meta: {NORMAL: true , POWER: true, ADMIN: true}
        },
        get('/logout', 'logout', Logout, 'Logout', true, true, true, true),
        get('/loader', 'loader', Loader, 'Loader'),
        get('/problem', 'problem', Problem, 'Problem', true, true, true),
        get('/account_setup', 'account_setup', AccountSetup, 'Account Setup', true, true, true),

        {path : '*', redirect : {name: 'problem', query: {reason: 'other'}}}
    ]

});

function get(path, name, component, ftitle, normal, power, admin, dh = false, hideInNonDh = false) {
    return {
        path: path, name: name, components: {default: component}, props: {default: {ftitle: ftitle}}, meta: {NORMAL: normal , POWER: power, ADMIN: admin, dh: dh, hideInNonDh: hideInNonDh}
    };
}

export default router;
